module.exports = __webpack_public_path__ + "static/media/return.6111501b.png";